import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useHttp from "../../../../hooks/use-http";
// import convertToExcel from "../../../../components/ExportToExcel";
// import convertToExcel from "./ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { AutoComplete } from "antd";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import convertToExcel from "../../../../components/ExportToExcel";

const WetHarvestDetailReport = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/farmerwise");
  };
  const formatNumber = (num) => {
    if (num === null || num === undefined) return "0.00";
    return Number(num).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  const [seasonData, setSeasondata] = useState([]);
  const [RanchData, setRanchdata] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [seasonId, setSeasonId] = useState();
  const [ranchId, setRanchId] = useState();
  const [seasonName, setSeasonName] = useState();
  const [RanchName, setRanchName] = useState();
  const [farmerNumber, setFarmerNumber] = useState("");
  const [farmerData, setFarmerData] = useState();
  const [showDateFilter, setShowDateFilter] = useState(false);

  const handleDateFilterChange = (e) => {
    setShowDateFilter(e.target.value === "Yes");
  };

  const [data, setData] = useState([]);

  const [loading, setLoading] = useState(false);

  const itemsPerPage = localStorage.getItem("pageSize") || 10;
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleFDateChange = (e) => {
    setSelectedFromDate(e.target.value);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 30);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);
  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getRanchWeighBridgeFarmerData } = useHttp();

  const fillRanchWeighBridgeFarmerData = (
    employeeId,
    seasonId,
    farmerNo,
    ranchId,
    getType = ""
  ) => {
    var urlfilter = "";

    if (showDateFilter) {
      urlfilter = urlfilter + `&fromDate=${selectedFromDate}`;
      urlfilter = urlfilter + `&toDate=${selectedToDate}`;
    }

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    if (ranchId && ranchId !== "") {
      urlfilter += `&ranchId=${ranchId}`;
    }

    if (seasonId && seasonId != "") {
      urlfilter = urlfilter + `&seasonId=${seasonId}`;
    }

    if (farmerNo != "") {
      urlfilter = urlfilter + `&farmerNo=${farmerNo}`;
    }

    if (getType != "") {
      urlfilter = urlfilter + `&getType=${getType}`;
    }

    var url = `/api/wetHarvestDetailReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter} `;

    getRanchWeighBridgeFarmerData(
      {
        url: url,
      },
      (data) => {
        if (getType == "Excel") {
        } else {
          setData(data);
        }
      }
    );
  };

  useEffect(() => {
    fillRanchWeighBridgeFarmerData(0, 0, "");
  }, [getRanchWeighBridgeFarmerData]);

  const handleExportExcel = async () => {
    const filename = "WetHarvestDetailReport.xlsx";

    const headers = [
      "Doc No",
      "Procurement Date",
      "Harvesting Date",
      "Farmer No",
      "Farmer Name",
      "Crop Name",
      "Field",
      "Season Name",
      "Region Name",
      "Plot Name",
      "Executive Name",
      "Total Quantity",
      "Total Amount",
      "Good - No. of Container",
      "Good - Quantity",
      "Good - Avg. Weight Of Crates (Kg)",
      "Good - Total Amount",
      "Good - Rate For Good",
      "Bad - No. of Container",
      "Bad - Quantity",
      "Bad - Avg. Weight Of Crates (Kg)",
      "Bad - Total Amount",
      "Bad - Rate For Bad",
      "Input Loan Cost",
      "Administrative Cost",
      "Total Loan Cost",
      "Remaining Loan Amount",
      "Final Payable Amount",
      "Payment Method",
    ];

    // Data rows
    const rows = data.map((itm) => [
      itm.docNo,
      itm.procurementDate,
      itm.harvestingDate,
      itm.farmerNo,
      itm.farmerName,
      itm.cropName,
      itm.ranchName,
      itm.seasonName,
      itm.regionName,
      itm.plotName,
      itm.executiveName,
      itm.totalQuantity,
      itm.totalAmount,
      itm.goodContainerNumber,
      itm.goodtotalQuantity,
      itm.goodAverageWeightOfCratesInKg,
      itm.goodTotalAmount,
      itm.rateForGoods,
      itm.badContainerNumber,
      itm.badtotalQuantity,
      itm.badAverageWeightOfCratesInKg,
      itm.badTotalAmount,
      itm.rateForBad,
      itm.inputLoanCost,
      itm.administrativeLoanCost,
      itm.totalLoanCost,
      itm.remainingLoanAmount,
      itm.finalPayableAmount,
      itm.paymentMethod,
    ]);

    // Combine headers + data
    const wsData = [headers, ...rows];

    // Create worksheet & workbook
    const ws = XLSX.utils.aoa_to_sheet(wsData);
    const colWidths = headers.map((h, i) => {
      let maxLen = h.length; // header length
      rows.forEach((row) => {
        const cellValue = row[i] ? row[i].toString() : "";
        if (cellValue.length > maxLen) maxLen = cellValue.length;
      });
      return { wch: maxLen + 2 }; // add padding
    });
    ws["!cols"] = colWidths;
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Wet Harvest Detail Report");

    // Save file
    XLSX.writeFile(wb, filename);
  };

  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = () => {
    getEmp(
      {
        url: `/api/employeeListForProcReort/?useCase=Procurement&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")} `,
      },
      (data) => {
        var emplist = data;

        setEmployeeData(emplist);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail();
  }, [getEmp]);

  const { sendRequest: getSeasonData } = useHttp();
  useEffect(() => {
    getSeasonData(
      {
        url: `/api/seasons/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        // console.log("season", data);

        setSeasondata(data);
      }
    );
  }, [getSeasonData]);

  const { sendRequest: getRanchData } = useHttp();
  useEffect(() => {
    getRanchData(
      {
        url: `/api/ranchDetail/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        // console.log("season", data);

        setRanchdata(data);
      }
    );
  }, [getRanchData]);

  const { sendRequest: getFarmerNumber } = useHttp();
  useEffect(() => {
    if (!employeeId || isNaN(employeeId)) return;
    getFarmerNumber(
      {
        url: `/api/farmerNumberList/?orgId=${localStorage.getItem(
          "orgId"
        )}&empId=${localStorage.getItem(
          "empId"
        )}&fieldExecutiveId=${employeeId}`,
      },
      (data) => {
        setFarmerData(data);
      }
    );
  }, [employeeId]);

  const handleSearch = (value) => {
    setFarmerNumber(value);
    setData([]);
  };

  // const options = farmerData&&farmerData.map(item => ({ value: item.identificationNo }));

  const filteredOptions =
    farmerData &&
    farmerData
      .filter((item) => item.farmerNo.includes(farmerNumber))
      .map((item) => ({ value: item.farmerNo }));

  //console.log(filteredOptions);

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-md-8 mt-3">
            <label className="card-title mx-3">Wet Harvest Detail Report</label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              {/* Season Name */}
              <div className="col-md-3">
                <div className="form-group">
                  <label>Season Name</label>
                  <select
                    id="seasonId"
                    className="form-control"
                    ref={(el) => (frmRef.current["seasonId"] = el)}
                    value={seasonId}
                    onChange={(e) => {
                      var sId = "";
                      if (e.target.value != "--Select--") {
                        sId = e.target.value;
                      }
                      // setSeasonName(sName);
                      setSeasonId(sId);
                      EmployeeDetail(sId);
                      setEmployeeId(0);
                      setData([]);
                    }}
                  >
                    <option value="">Select</option>
                    {seasonData &&
                      seasonData.map((x) => (
                        <option key={x.seasonId} value={x.seasonId}>
                          {x.seasonName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              {/* Ranch Name */}
              <div className="col-md-3">
                <div className="form-group">
                  <label>Ranch Name</label>
                  <select
                    id="ranchId"
                    className="form-control"
                    ref={(el) => (frmRef.current["ranchId"] = el)}
                    value={ranchId}
                    onChange={(e) => {
                      var rId = "";
                      if (e.target.value != "--Select--") {
                        rId = e.target.value;
                      }
                      setRanchId(rId);
                      // setRanchName(rId)
                      setEmployeeId(0);
                      setData([]);
                    }}
                  >
                    <option value="">Select</option>
                    {RanchData &&
                      RanchData.map((x) => (
                        <option key={x.ranchId} value={x.ranchId}>
                          {x.ranchName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              {/* Procurement Officer */}
              <div className="col-md-3">
                <div className="form-group">
                  <label>Harvest Officer</label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      var userid = 0;
                      if (e.target.value != "--Select--")
                        userid = e.target.value;
                      setData([]);
                      setEmployeeId(userid);
                    }}
                  >
                    <option value="0">Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option key={x.userId} value={x.userId}>
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              {/* Farmer Number */}
              <div className="col-md-3">
                <label htmlFor="farmer_number">Farmer Number</label>
                <AutoComplete
                  className="form-control"
                  style={{ height: "30px" }}
                  value={farmerNumber}
                  options={filteredOptions}
                  placeholder="Farmer Number"
                  onChange={handleSearch}
                />
              </div>

              {/* Date Filter */}
              <div className="col-md-3">
                <div className="form-group">
                  <label>Apply Date Filter</label>
                  <select
                    id="date_filter"
                    className="form-control"
                    ref={(el) => (frmRef.current["date_filter"] = el)}
                    onChange={handleDateFilterChange}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>

              {showDateFilter && (
                <>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>From Date</label>
                      <input
                        type="date"
                        className="form-control"
                        max={currentDate}
                        value={selectedFromDate}
                        onChange={handleFDateChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>To Date</label>
                      <input
                        type="date"
                        className="form-control"
                        max={currentDate}
                        value={selectedToDate}
                        onChange={handleTDateChange}
                      />
                    </div>
                  </div>
                </>
              )}

              {/* Submit */}
              <div className="col-md-3 text-right">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillRanchWeighBridgeFarmerData(
                        employeeId,
                        seasonId,
                        farmerNumber,
                        ranchId
                      );
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        {/* Report Table */}
        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning mx-3"
                onClick={handleExportExcel}
                disabled={loading}
              >
                {loading ? (
                  <i className="fas fa-spinner fa-spin"></i>
                ) : (
                  <i className="fas fa-file-excel"></i>
                )}
              </button>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        <tr className="table-header">
                          <th rowSpan="2">Doc No</th>
                          <th rowSpan="2">Procurement Date</th>
                          <th rowSpan="2">Harvesting Date</th>
                          <th rowSpan="2">Farmer No</th>
                          <th rowSpan="2">Farmer Name</th>
                          <th rowSpan="2">Crop Name</th>
                          <th rowSpan="2">Field</th>
                          <th rowSpan="2">Season Name</th>
                          <th rowSpan="2">Region Name</th>
                          <th rowSpan="2">Plot Name</th>
                          <th rowSpan="2">Executive Name</th>
                          <th rowSpan="2">Total Quantity</th>
                          <th rowSpan="2">Total Amount</th>
                          <th colSpan="5" className="text-center">
                            Good
                          </th>
                          <th colSpan="5" className="text-center">
                            Bad
                          </th>
                          <th rowSpan="2">Input Loan Cost</th>
                          <th rowSpan="2">Administrative Loan Cost</th>
                          <th rowSpan="2">Total Loan Cost</th>
                          <th rowSpan="2">Remaining Loan Amount</th>
                          <th rowSpan="2">Final Payable Amount</th>
                          <th rowSpan="2">Payment Method</th>
                        </tr>
                        <tr className="table-subheader">
                          {/* Good Columns */}
                          <th>No. of Container </th>
                          <th>Quantity</th>
                          <th style={{ minWidth: "80px" }}>
                            Avg. Weight Of Crates (Kg)
                          </th>
                          <th>Total Amount</th>
                          <th style={{ minWidth: "80px" }}>Rate For Good</th>

                          {/* Bad Columns */}
                          <th>No. of Container</th>
                          <th>Quantity</th>
                          <th style={{ minWidth: "80px" }}>
                            Avg. Weight Of Crates (Kg)
                          </th>
                          <th>Total Amount</th>
                          <th style={{ minWidth: "80px" }}>Rate For Bad</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => (
                            <tr key={i} className="tablerowview">
                              <td>{itm.docNo}</td>
                              <td>{itm.procurementDate}</td>
                              <td>{itm.harvestingDate}</td>
                              <td>{itm.farmerNo}</td>
                              <td>{itm.farmerName}</td>
                              <td>{itm.cropName}</td>
                              <td>{itm.ranchName}</td>
                              <td>{itm.seasonName}</td>
                              <td>{itm.regionName}</td>
                              <td>{itm.plotName}</td>
                              <td>{itm.executiveName}</td>
                              <td>{itm.totalQuantity}</td>
                              <td>{itm.totalAmount}</td>
                              
                              <td>{itm.goodContainerNumber}</td>
                              <td>{itm.goodtotalQuantity}</td>
                              <td>{itm.goodAverageWeightOfCratesInKg}</td>
                              <td>{itm.goodTotalAmount}</td>
                              <td>{itm.rateForGoods}</td>

                              <td>{itm.badContainerNumber}</td>
                              <td>{itm.badtotalQuantity}</td>
                              <td>{itm.badAverageWeightOfCratesInKg}</td>
                              <td>{itm.badTotalAmount}</td>
                              <td>{itm.rateForBad}</td>

                              <td>{itm.inputLoanCost}</td>
                              <td>{itm.administrativeLoanCost}</td>
                              <td>{itm.totalLoanCost}</td>
                              <td>{itm.remainingLoanAmount}</td>
                              <td>{itm.finalPayableAmount}</td>
                              <td>{itm.paymentMethod}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default WetHarvestDetailReport;
